import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { ComparisonComponent } from '../../../tabs/comparison/comparison.component';
import { ProductContentModule } from '../product-content/product-content.module';
import { SideNavComponent } from '../sidenav/sidenav.component';
import { ProductOverviewComponent } from './product-overview.component';
import { ProductOverViewRoutingModule } from './products-overview-routing.module';

@NgModule({
  declarations: [ProductOverviewComponent, SideNavComponent, ComparisonComponent],
  imports: [ProductOverViewRoutingModule, ProductContentModule, CommonModule, FormsModule, ReactiveFormsModule, TranslateModule],
  exports: [ProductOverviewComponent],
})
export class ProductOverviewModule {}
